import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button } from "@mantine/core";
import { IconDeviceTvFilled } from "@tabler/icons-react";
import { openDiscordProps } from "../ButtonVariants";
import classes from "./needHelpBanner.module.css";

const ButtonHelpBannerDiscord: React.FC = () => {
  const { t } = useAppTranslation("common.helpBanner");
  return (
    <Button
      className="hover-scale w-full bg-primary-default/50 font-black font-inter text-primary-light-text text-sm backdrop-blur hover:bg-primary-default/70 sm:w-auto"
      classNames={classes}
      fw={"bold"}
      leftSection={<IconDeviceTvFilled height={24} width={24} />}
      radius={8}
      size="lg"
      variant="light"
      {...openDiscordProps}
    >
      {t("chatButton")}
    </Button>
  );
};

export default ButtonHelpBannerDiscord;
